var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.33027 7.72554H0.384857V23.2706H5.33027V7.72554ZM5.73437 2.80074C5.73437 1.2594 4.4451 0 2.86719 0C1.28927 0 0 1.2594 0 2.80074C0 4.34209 1.28927 5.60149 2.86719 5.60149C4.4451 5.60149 5.73437 4.34209 5.73437 2.80074ZM13.2002 7.72579H8.44727V23.2709H13.3927V15.5829C13.3927 13.5716 13.7775 11.598 16.3561 11.598C18.8961 11.598 18.9346 13.91 18.9346 15.7145V23.2709H23.88V14.7371C23.88 10.5453 22.9564 7.33105 17.9532 7.33105C15.5479 7.33105 13.9315 8.62804 13.2772 9.84984H13.2002V7.72579Z","fill":"currentColor"}));
}

Linkedin.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
